export default __webpack_public_path__ + "5665d624d5b6625dd71c7fb10d78a589.svg";